import { WILDCARD } from '@ardoq/common-helpers';
import { ItemLabels, RawGraphNode2 } from '../types';
import { CollapsibleGraphGroup } from './CollapsibleGraphGroup';

const graphGroupsMap = (
  groupMap: Map<string, RawGraphNode2>,
  collapsedGroupIds: Set<string>,
  itemLabelsData: Map<string, ItemLabels>,
  contextComponentId: string
) =>
  new Map(
    Array.from(groupMap.values()).map(rawGraphItem => [
      rawGraphItem.id,
      CollapsibleGraphGroup.createFrom(
        rawGraphItem,
        collapsedGroupIds.has(WILDCARD) ||
          collapsedGroupIds.has(rawGraphItem.id),
        itemLabelsData?.get(rawGraphItem.id),
        Boolean(
          contextComponentId && contextComponentId === rawGraphItem.modelId
        )
      ),
    ])
  );

export { graphGroupsMap };
